import React, { useState, useEffect } from 'react';
import { startCase } from 'lodash';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  IconButton,
  TextField,
} from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close';
import { withStyles } from '@material-ui/core/styles';

import Button from '../Button'
import SearchableSelect from '../SearchableSelect';

function AppointmentEditModal(props) {
  const {
    appointment,
    open,
    save,
    onClose,
    statuses,
    classes: {
      modal,
      modalContent,
      actions,
      input,
      selectInput,
    }
  } = props;

  const [status, setStatus] = useState(null);

  useEffect(()=>{
    const body = document.querySelector("body");
    if(open){
      body.style.overflow = "hidden";
      body.style.position ="fixed";
      body.style.width ="100%";
      body.style.height ="100%";


    }
    else{
      body.style.overflow = "auto";
      body.style.height = "auto"
    }
    return()=>{
      body.style.overflow = "auto";
      body.style.overflow = "hidden";
      body.style.position ="static";
      body.style.width ="auto";
      body.style.height ="auto";
    }
  },[open])

  useEffect(() => {
    setStatus({ value: appointment.status, label: startCase(appointment.status) })
  }, [appointment])

  const onSave = () => {
    save({ id: appointment.id, status: status.value });
  }

  return (
    <Dialog
      fullWidth
      open={open}
      onClose={onClose}
      classes={{ paper: modal }}
    >
      <DialogTitle>
        <Grid container alignItems="center">
          <Grid item xs={11}>
            <h2>Appointment</h2>
          </Grid>

          <Grid item xs={1}>
            <IconButton aria-label="Close" onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </Grid>
        </Grid>
      </DialogTitle>


      <DialogContent classes={{ root: modalContent }}>
        <SearchableSelect
          searchable
          label="Status"
          name="status"
          placeholder=""
          value={status}
          options={statuses}
          onChange={setStatus}
          className={selectInput}
        />

        <TextField
          fullWidth
          multiline
          disabled
          rows="5"
          variant="outlined"
          label="Notes"
          name="portalNotes"
          value={appointment.portalNotes}
          className={input}
        />

        <Grid container justifyContent="center" style= {{textAlign: 'center'}} classes={{ container: actions }}>
          <Grid item xs={12} lg={3}>
            <Button
              fullWidth
              color="primary"
              variant="contained"
              onClick={onSave}
            >
              Update
            </Button>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
}

AppointmentEditModal.propTypes = {
  appointment: PropTypes.object,
  open: PropTypes.bool.isRequired,
  save: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

const styles = () => ({
  modal: {
    maxHeight: '700px',
  },
  modalContent: {
    overflow: 'visible',
  },
  actions: {
    marginTop: '1em',
  },
  input: {
    margin: '0.5em 0',
  },
  selectInput: {
    marginTop: '0.5em',
    marginBottom: '1em',
  },
});

export default withStyles(styles)(AppointmentEditModal);
